import { IdCodeLibelle } from '../../id-code-libelle.abstract.model';

export class TypeVin extends IdCodeLibelle {}
